import { atom } from 'jotai';

const deepGet = (obj, path, defaultValue) => {
  if (!path) return obj;
  const keys = path.split('.');
  let current = obj;
  for (const key of keys) {
    if (current === null || current === undefined) return defaultValue;
    current = current[key];
  }
  return current !== undefined ? current : defaultValue;
};

// AGGIUNTO: parametro options per intercettare { isInit: true }
const deepSet = (obj, path, value, options = {}) => {
  if (!path) return value;
  const keys = path.split('.');

  // Estraiamo il flag
  const isInit = options.isInit === true;

  const result = Array.isArray(obj) ? [...obj] : { ...obj };

  // 1. Modifichiamo formChanged SOLO se NON è un'inizializzazione silenziosa
  if (!Array.isArray(result) && !isInit) {
    result.formChanged = true;
  }

  let current = result;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];

    if (current[key] === undefined || current[key] === null) {
      // If a nested level doesn't exist yet, default to an object.
      // (Arrays are pre-initialized by the components, so they will already exist here)
      current[key] = {};
    } else {
      // If it already exists, accurately clone it based on its active type
      current[key] = Array.isArray(current[key])
        ? [...current[key]]
        : { ...current[key] };
    }

    current = current[key];

    // 2. Mark the parent Section and Filter objects as changed along the way
    // (Di nuovo, SOLO se non è un'inizializzazione)
    if (!Array.isArray(current) && !isInit) {
      current.formChanged = true;
    }
  }

  // 3. Commit the final input value
  current[keys[keys.length - 1]] = value;
  return result;
};

export const genericFormAtom = atom({});

export const makeGenericFieldAtom = (path, defaultValue) => {
  return atom(
    (get) => deepGet(get(genericFormAtom), path, defaultValue),
    (get, set, newValue, options) => {
      set(genericFormAtom, (prevState) =>
        deepSet(prevState || {}, path, newValue, options)
      );
    }
  );
};
